import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { ExternalUserForm } from '../components/ExternalUserForm';
import { useExternalUser, useUpdateExternalUser } from '../../../../hooks/users/useExternalUsers';
import type { UpdateExternalUserDto } from '../../types/external-user.types';

export const ExternalUserEditPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const { data: user, isLoading } = useExternalUser(id!);
  const updateMutation = useUpdateExternalUser();

  const handleSubmit = async (data: UpdateExternalUserDto) => {
    if (!id) return;

    try {
      await updateMutation.mutateAsync({ id, data });
      navigate(`/users-externes/${id}`);
    } catch (error) {
      console.error('Erreur modification:', error);
    }
  };

  if (isLoading) {
    return (
      <div className="tw-flex tw-justify-center tw-items-center tw-min-h-screen">
        <Loader2 className="tw-h-10 tw-w-10 tw-animate-spin tw-text-white tw-text-opacity-900" />
      </div>
    );
  }

  if (!user) {
    return <div className="tw-p-6">Utilisateur non trouvé</div>;
  }

  return (
    <div className="tw-p-6 tw-max-w-4xl tw-mx-auto">
      <button
        onClick={() => navigate(`/users-externes/${id}`)}
        className="tw-flex tw-items-center tw-gap-2 tw-text-gray-600 hover:tw-text-gray-900 tw-mb-6"
      >
        <ArrowLeft className="tw-w-5 tw-h-5" />
        Retour au détail
      </button>

      <div className="tw-bg-white tw-rounded-lg tw-shadow-md tw-p-6">
        <h1 className="tw-text-2xl tw-font-bold tw-text-gray-900 tw-mb-6">
          Modifier l'utilisateur externe
        </h1>

        <ExternalUserForm
          initialData={user}
          onSubmit={handleSubmit}
          onCancel={() => navigate(`/users-externes/${id}`)}
          isLoading={updateMutation.isLoading}
          isEdit
        />
      </div>
    </div>
  );
};

